import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import ISubject, { ISubjectInput } from "@/interfaces/subject.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class SubjectService {
  private baseUrl = "api/v1/Subject";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ISubject>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.get<PaginatedResponse<ISubject>>(
      `${this.baseUrl}?${paginationQuery}`
    );
  }

  async filter(
    filter: IFilter<ISubject>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ISubject>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.post<PaginatedResponse<ISubject>>(
      `${this.baseUrl}/filter?${paginationQuery}`,
      {
        filter,
      }
    );
  }

  async getById(subjectId: number): Promise<ISubject> {
    return await httpRequest.get<ISubject>(`${this.baseUrl}/${subjectId}`);
  }

  async create(formData: ISubjectInput): Promise<ISubject> {
    return await httpRequest.post<ISubject>(this.baseUrl, formData);
  }

  async update(formData: ISubjectInput, subjectId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${subjectId}`, formData);
  }

  async delete(subjectId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${subjectId}`);
  }
}

export default new SubjectService();
